/** zh-CN catalogue `noteLane` (W3-09; English: src/features/note-lane/noteLane.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const BEATS = '{beats} {one, select, yes {拍} other {拍}}';

const catalog: MessageCatalog = {
  ns: 'noteLane',
  locale: 'zh-CN',
  messages: {
    panelTimeline: '时间轴',
    panelTools: '工具',
    laneColumn: '音符轨道',
    laneRegion: '音符轨道与运动列',
    lineUnnamed: '判定线 {index}',
    noLine: '无判定线',
    toolsLabel: '音符工具',
    toolSelect: '选择工具',
    toolSelectHint: '{keys} 选择“选择”工具：单击选中，拖动可移动或框选',
    toolTap: 'Tap 工具',
    toolTapHint: '{keys} 选择 Tap 工具：在轨道上单击放置 Tap',
    toolDrag: 'Drag 工具',
    toolDragHint: '{keys} 选择 Drag 工具',
    toolFlick: 'Flick 工具',
    toolFlickHint: '{keys} 选择 Flick 工具',
    toolHold: 'Hold 工具',
    toolHoldHint: '{keys} 选择 Hold 工具：在起点按下并向上拖动到终点',
    toolEraser: '橡皮擦工具',
    toolEraserHint: '{keys} 选择橡皮擦：单击或拖过音符即可删除',
    toolSelectShort: '选择',
    toolTapShort: 'Tap',
    toolDragShort: 'Drag',
    toolFlickShort: 'Flick',
    toolHoldShort: 'Hold',
    toolEraserShort: '橡皮擦',
    generators: '生成器',
    generatorsShort: '工具',
    genDistribute: '分布（数值渐变）',
    genClone: '克隆到判定线',
    genFill: '在音符之间填充',
    genPath: '运动路径',
    genTemplates: '运动模板',
    genNeedsLine: '请先选择一条判定线',
    kindName: '{kind, select, tap {Tap} drag {Drag} flick {Flick} hold {Hold} other {音符}}',
    placeTap: '在鼠标处放置 Tap',
    placeTapHint: '{keys} 在鼠标处放置 Tap',
    placeDrag: '在鼠标处放置 Drag',
    placeDragHint: '{keys} 在鼠标处放置 Drag',
    placeFlick: '在鼠标处放置 Flick',
    placeFlickHint: '{keys} 在鼠标处放置 Flick',
    placeTapAtPlayhead: '在播放头处放置 Tap',
    placeTapAtPlayheadHint: '{keys} 在播放头处放置 Tap',
    placeDragAtPlayhead: '在播放头处放置 Drag',
    placeDragAtPlayheadHint: '{keys} 在播放头处放置 Drag',
    placeFlickAtPlayhead: '在播放头处放置 Flick',
    placeFlickAtPlayheadHint: '{keys} 在播放头处放置 Flick',
    holdAtMouse: '在鼠标处开始或结束 Hold',
    holdAtMouseHint: '{keys} 在鼠标处开始 Hold；再按 {keys} 结束',
    holdAtPlayhead: '在播放头处开始或结束 Hold',
    holdAtPlayheadHint: '{keys} 在播放头处开始 Hold；再按 {keys} 结束（播放时也可使用）',
    cancelHold: '取消正在放置的 Hold',
    mouseClick: '单击',
    hintPlace: '在 {beat}、X {x} 处放置 {kind}',
    hintPlaceHold: '并向上拖动，从 {beat}、X {x} 处放置 Hold',
    hintErase: '或拖过音符以删除它们',
    gestureEndHold: '结束 Hold',
    gestureCancel: '取消',
    gestureNoSnap: '忽略吸附',
    gestureAxisLock: '只沿一个方向移动',
    gestureAroundPlayhead: '以播放头为中心',
    gestureAroundZero: '以 X 0 为中心',
    gestureStack: '放在另一个音符上',
    holdLength: `${BEATS}，{sec} 秒`,
    noLineTitle: '未选择判定线',
    noLineBody: '在轨道标题或判定线面板中选择一条判定线，即可查看和放置其音符。',
    emptyLaneTitle: '此判定线上还没有音符',
    emptyLaneBody:
      '选择 Tap 工具{tapTool, select, none {} other {（{tapTool}）}}并在此处单击{placeTap, select, none {。} other {，或指向此处并按 {placeTap}。}}',
    uiMoverTitle: '此判定线绑定了{element}的显示',
    uiMoverBody: '其上的音符将不可见，因此音符工具已关闭。',
    uiElement:
      '{element, select, pause {暂停按钮} combonumber {连击数} combo {连击标签} score {分数} bar {进度条} name {曲名} level {难度} other {界面}}',
    lockedTitle: '此判定线已锁定',
    lockedBody: '请在判定线面板中解锁后再编辑其音符。',
    reasonNoProject: '请先打开一个项目',
    reasonNoLine: '请先选择一条判定线',
    reasonNoNotes: '请先选中音符',
    reasonNoHolds: '请先选中 Hold',
    reasonNoSelection: '请先选中音符或关键帧',
    reasonNotOverLane: '请先指向音符轨道',
    reasonUiMover: '此判定线绑定了显示元素；其上的音符将不可见',
    reasonLocked: '此判定线已锁定（判定线面板）',
    reasonGesture: '请先完成当前的拖动',
    reasonOpacityOnly: 'S 将不透明度关键帧设为 100%；选中内容中还有其他关键帧',
    reasonNoTimeRange: '请先在时间栏中拖动以选择一段时间范围',
    reasonNoMarkers: '此谱面还没有标记',
    reasonNoMarker: '请先在时间栏中右键单击一个标记，或选中一个标记',
    reasonNoPaste: '当前没有粘贴预览',
    reasonNoHoldPlacing: '当前没有正在放置的 Hold',
    reasonNoOtherLine: '没有其他判定线',
    mirror: 'X 镜像',
    mirrorHint: '{keys} 镜像 X（以 0 为中心）',
    mirrorCenter: '以选区中心镜像',
    mirrorCenterHint: '{keys} 以选区中心镜像',
    flipSide: '翻转方向',
    flipSideHint: '{keys} 翻转方向（上方 / 下方）',
    setTop: '放到上方',
    setBottom: '放到下方',
    toggleFake: '切换假键',
    toggleFakeHint: '{keys} 将音符设为假键或真键',
    setFake: '设为假键',
    setReal: '设为真键',
    toTap: '转换为 Tap',
    toDrag: '转换为 Drag',
    toFlick: '转换为 Flick',
    toHold: '转换为 Hold',
    snapX: '将 X 吸附到网格',
    quantize: '将时间吸附到节拍网格',
    reverse: '时间反转',
    nudgeLater: '后移',
    nudgeLaterHint: '{keys} 将选中内容后移一个吸附步长',
    nudgeEarlier: '前移',
    nudgeRight: '右移',
    nudgeRightHint: '{keys} 将音符移动半个 X 网格步长',
    nudgeLeft: '左移',
    wheelWidth: '微调音符宽度',
    wheelWidthHint: '{keys} 让选中的音符变宽或变窄',
    argWidthSteps: '以 10% 为步长（负数：变窄）',
    holdLonger: '将 Hold 延长一个步长',
    holdShorter: '将 Hold 缩短一个步长',
    transformDialog: '变换选中内容…',
    argSteps: '步数',
    copy: '复制',
    copyHint: '{keys} 复制选中内容',
    cut: '剪切',
    paste: '粘贴',
    pasteHint: '{keys} 在鼠标处粘贴',
    pasteGhost: '带预览粘贴',
    pasteImmediate: '立即粘贴',
    duplicate: '在选中内容后创建副本',
    duplicateHint: '{keys} 在选中内容之后紧接着创建副本',
    delete: '删除',
    deleteHint: '{keys} 删除选中内容',
    selectAll: '全选',
    selectAllHint: '{keys} 选中此列的全部内容；再按一次：整条判定线',
    argPasteVariant: '粘贴方式',
    pasteNormal: '粘贴',
    pasteMirrored: '镜像粘贴',
    pasteAddValues: '将数值叠加到曲线上',
    pasteSpecialChoice: '选择性粘贴…',
    itemsNotes: '{count, plural, other {# 个音符}}',
    itemsKeys: '{count, plural, other {# 个关键帧}}',
    itemsSegments: '{count, plural, other {# 个区段}}',
    itemsMarkers: '{count, plural, other {# 个标记}}',
    listJoin: '{a}、{b}',
    toastCopied: '已复制 {items}（{from} 到 {to}）',
    toastCut: '已剪切 {items}（{from} 到 {to}）',
    toastPasted: '已粘贴 {items}',
    toastUnmatched: '{count, plural, other {# 个值}}没有找到可叠加的关键帧',
    actionPasteRest: '将其余部分作为新层级粘贴',
    toastDuplicated: '已为 {items}创建副本',
    toastDeleted: '已删除 {items}',
    toastNothingToPaste: '剪贴板为空：请先复制内容{keys, select, none {} other {（{keys}）}}',
    toastNothingCopied: '请选中要复制的音符或关键帧',
    toastMirrored: '已镜像 {notes}，并将 {keys} 取反',
    toastErased: '已擦除 {items}',
    ghostLabel:
      '将 {count, plural, other {# 个音符}}粘贴到 {line}{mirror, select, yes {（镜像）} other {}}：Enter 或单击放置，Esc 取消',
    ghostLabelKeys: '将 {items}粘贴到 {line}：Enter 或单击放置，Esc 取消',
    ghostLabelLocked: '{line} 已锁定：按 Tab 选择另一条判定线',
    ghostMirror: '镜像',
    ghostLine: '其他判定线',
    ghostShift: '后移 / 前移一步',
    ghostCommit: '粘贴到此处',
    ghostCancel: '取消',
    pasteMirrorToggle: '粘贴预览：镜像',
    pasteNextLine: '粘贴预览：下一条判定线',
    pastePrevLine: '粘贴预览：上一条判定线',
    pasteLater: '粘贴预览：后移一步',
    pasteEarlier: '粘贴预览：前移一步',
    pasteCommit: '在预览处粘贴',
    pasteCommitHint: '{keys} 在预览处粘贴',
    pasteCancel: '取消粘贴',
    txPlace: '放置{kind, select, tap { Tap} drag { Drag} flick { Flick} hold { Hold} other {音符}}',
    txMove: '移动 {count, plural, other {# 个音符}}',
    txMoveItems: '移动 {count, plural, other {# 个项目}}',
    txHoldLength: '修改 {count, plural, other {# 个 Hold}}',
    txDelete: '删除 {items}',
    txMirror: '镜像 {count, plural, other {# 个音符}}',
    txFlip: '翻转 {count, plural, other {# 个音符}}的方向',
    txSide: '设置 {count, plural, other {# 个音符}}的方向',
    txFake: '修改 {count, plural, other {# 个音符}}的假键状态',
    txConvert:
      '将 {count, plural, other {# 个音符}}转换为{kind, select, tap { Tap} drag { Drag} flick { Flick} hold { Hold} other {音符}}',
    txSnapX: '吸附 {count, plural, other {# 个音符}}的 X',
    txQuantize: '吸附 {count, plural, other {# 个音符}}的时间',
    txReverse: '在时间上反转 {count, plural, other {# 个项目}}',
    txNudge: '微调 {count, plural, other {# 个项目}}',
    txStretch: '拉伸 {count, plural, other {# 个项目}}的时间',
    txScaleX: '缩放 {count, plural, other {# 个音符}}的 X',
    txPaste: '粘贴 {items}',
    txCut: '剪切 {items}',
    txDuplicate: '为 {items}创建副本',
    txErase: '擦除 {count, plural, other {# 个音符}}',
    txWidth: '修改 {count, plural, other {# 个音符}}的宽度',
    txInsertTime: `插入 ${BEATS}`,
    txRemoveTime: `移除 ${BEATS}`,
    txMarkerAdd: '添加标记“{name}”',
    txMarkerRename: '将标记重命名为“{name}”',
    txMarkerDelete: '删除标记“{name}”',
    markerAdd: '添加标记',
    markerAddHint: '{keys} 在播放头处添加标记',
    markerPrev: '上一个标记',
    markerNext: '下一个标记',
    markerRename: '重命名标记…',
    markerDelete: '删除标记',
    markerDefaultName: '标记 {n}',
    toastMarkerAdded: '已在 {beat} 添加“{name}”',
    actionRename: '重命名',
    toastNoPrevMarker: '播放头之前没有标记',
    toastNoNextMarker: '播放头之后没有标记',
    renameTitle: '重命名标记',
    renameLabel: '名称',
    renameConfirm: '重命名',
    renameEmpty: '请输入标记名称',
    timeInsert: '在播放头处插入拍…',
    timeRemove: '移除选中的时间范围…',
    insertTitle: '在播放头处插入拍',
    insertBody:
      '{beat} 及之后的所有内容都会后移：音符、关键帧、速度点、标记、特效和视频。跨越该点的区段会被拉伸（其曲线保持形状）。',
    insertBodyLines: '所选判定线上 {beat} 及之后的音符和关键帧会后移。跨越该点的区段会被拉伸。',
    insertLength: '要插入的拍数',
    insertConfirm: '插入',
    scopeLabel: '应用于',
    scopeAll: '整张谱面',
    scopeActive: '仅 {line}',
    scopeChosen: '这些判定线',
    removeTitle: '移除选中的时间范围',
    removeBody: `从 {from} 到 {to} 的音符会被删除。区段会在两端拆分（不改变形状）并跨过空隙连接，之后的所有内容都会前移 ${BEATS}。`,
    removeConfirm: '移除',
    cancel: '取消',
    toastInserted: `已插入 ${BEATS}：移动了 {notes, plural, other {# 个音符}}、{keys, plural, other {# 个关键帧}}、{tempo, plural, other {# 个速度点}}`,
    toastRemoved: `已移除 ${BEATS}：删除了 {deleted, plural, other {# 个音符}}，移动了 {notes, plural, other {# 个音符}}、{keys, plural, other {# 个关键帧}}、{tempo, plural, other {# 个速度点}}`,
    argBeats: '要插入的拍数',
    invalidLength: '请输入大于 0 的长度',
    headerLine: '判定线',
    headerLinePick: '要编辑其音符的判定线',
    addLine: '添加判定线',
    headerAlso: '同时显示',
    headerAlsoAdd: '以虚影显示另一条判定线的音符',
    headerAlsoRemove: '不再显示 {line}',
    headerSides: '方向',
    sidesBoth: '两侧',
    sidesAbove: '仅上方',
    sidesBelow: '仅下方',
    headerXGrid: 'X 网格线',
    headerXSnap: '将 X 吸附到网格',
    zoomXIn: '放大轨道 X',
    zoomXOut: '缩小轨道 X',
    fitX: '使轨道适应游玩区域和音符',
    plusX: '在屏幕上，播放头处的 +X 指向这个方向（轨道显示的是未旋转的判定线）',
    plusXNone: '没有可确定方向的判定线',
    pinLane: '将此判定线固定为额外轨道',
    unpinLane: '移除此额外轨道',
    makeActive: '编辑此判定线',
    alsoShow: '同时显示某条判定线的音符',
    alsoHide: '不再显示某条判定线的音符',
    alsoClear: '不再显示其他判定线',
    sides: '只显示一侧的音符',
    argLine: '判定线',
    argSides: '方向',
    holdMoveAlias: '按住以用鼠标移动音符（RPE）',
    holdDeleteAlias: '按住并右键单击音符以删除它们（RPE）',
    laneHelpTitle: '音符轨道',
    laneHelpBody:
      '音符轨道显示未旋转的当前判定线：时间向上推进，水平轴是沿判定线的位置（RPE X，屏幕上为 -675 到 675）。在左侧选择工具，或指向轨道并按放置音符的按键（默认键位中为 Q、W 和 E）来放置 Tap、Drag 和 Flick；Hold 的按键（R）开始和结束 Hold。拖动音符可移动它们，在空白处拖动可框选，右键单击查看更多操作。',
    tipTitle: '{kind}{fake, select, yes {（假键）} other {}}',
    tipBeat: '拍 {beat}',
    tipTime: '时间 {sec}',
    tipX: 'X {x}',
    tipLine: '判定线 {line}',
    tipSide: '{above, select, yes {上方} other {下方}}',
    tipHoldEnd: `结束于 {beat}（{length} {one, select, yes {拍} other {拍}}）`,
    tipStack: '此处有 {count} 个音符：{alt}+单击可循环选择',
    flagSimultaneous: '多押：在 Phira 中高亮显示',
    flagCover: '当前被判定线遮罩隐藏',
    flagNegativeAlpha: '当前已隐藏：判定线不透明度低于 0',
    flagCulled: '当前被剔除：速度为负或超出屏幕',
    flagUiMover: '不可见：位于 UI 绑定线上',
    flagBeforeAppear: '当前不可见：在其出现时间之前',
    flagOffscreen: '当前在屏幕外',
    flagFiltered: '在预览中被筛选隐藏',
    actionContinueFromPrevious: '粘合',
    settingWheelSeeks: '滚轮移动播放头（RPE）',
    settingWheelSeeksHelp: '用鼠标滚轮滚动时间轴时也会移动播放头，使预览显示播放头所在的时刻。Alt+滚轮滚动更快。',
    toastJumpMade:
      '{count, plural, =1 {已在 {at} 设为跳变} other {已设置 # 个跳变，第一个位于 {at}}}：钩定之后的值无法改变钩定的到达值',
    wheelSeeksOff: '从不（滚轮只滚动）',
    wheelSeeksOn: '始终',
    wheelSeeksPreset: '使用 RPE 键盘预设时',
    cmdUsabilityStart: '开始可用性测试',
    cmdUsabilityStop: '结束可用性测试',
    uxProfileTitle: '参与者是谁？',
    uxProfileFirstTime: '初次制谱的谱师',
    uxProfileRpe: 'RPE 用户',
    uxChip: '任务 {n} / {count}：{title}',
    uxChipDone: '所有任务都已完成',
    uxReached: '已达成目标',
    uxDone: '完成',
    uxGaveUp: '放弃',
    uxStop: '结束测试',
    uxStopped: '可用性测试已结束。打开 #/dev/usability 可将日志保存为文件。',
    uxPageTitle: '可用性测试',
    uxPageIntro:
      '照原文朗读每个任务，然后保持安静并观察。测试进行时，日志会记录编辑、按键、单击、提示和错误；在你保存之前，它会一直保留在此浏览器中。',
    uxPageStart: '在编辑器中开始测试：打开命令面板并运行“开始可用性测试”。',
    uxSay: '朗读',
    uxObserve: '观察要点',
    uxSuccess: '达成条件',
    uxLastLog: '上次测试：{participant}（{profile}），{tasks} 个任务，{events} 个事件',
    uxNoLog: '此浏览器中还没有记录过测试。',
    uxSaveLog: '保存日志（JSON）',
    uxClearLog: '删除日志',
    uxTaskOutcome: '{title}：{outcome}，{seconds} 秒，{commits} 次编辑，{undos} 次撤销',
    uxOutcomeNone: '未完成',
    uxTaskPattern: '放置一段配置',
    uxTaskPatternScript: '在第二小节中，放置一小段跟随音乐的节奏：八个音符，其中至少一个是 Hold。',
    uxTaskPatternObserve: '使用哪个工具或按键，是否找到节拍吸附，多久放下第一个音符。',
    uxTaskPatternSuccess: '八个新音符，其中一个是 Hold',
    uxTaskAnimate: '让判定线动起来',
    uxTaskAnimateScript: '让主线在两拍内从左边移动到右边，并在结尾减速。',
    uxTaskAnimateObserve: '是否找到关键帧（K、拖动判定线、模板）和缓动选择器。',
    uxTaskAnimateSuccess: '一个 100 px 或以上、缓动不是线性的位置区段',
    uxTaskFix: '修复一个问题',
    uxTaskFixScript: '编辑器报告了此谱面中的一个问题。找到并修复它。',
    uxTaskFixObserve: '是否注意到问题标签，是使用“修复”按钮还是手动修复。',
    uxTaskFixSuccess: '问题数量少于任务开始时',
    uxTaskTestPlay: '带判定的试玩',
    uxTaskTestPlayScript: '像玩家一样游玩你的谱面，亲自击打音符，直到结束。',
    uxTaskTestPlayObserve: '是否找到试玩和带判定的模式，以及如何回到编辑。',
    uxTaskTestPlaySuccess: '一次试玩到达了结果界面',
    uxTaskExport: '导出',
    uxTaskExportScript: '把谱面保存为一个可以在 Phira 中打开的文件。',
    uxTaskExportObserve: '是否找到“发布”和“导出”，以及如何理解导出前的检查。',
    uxTaskExportSuccess: '一次新的导出',
  },
};

export default catalog;
